import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { getCoreSonarObjectsApplicationsAsyncSlice } from './get';

export const coreSonarObjectsApplicationsReducers = combineReducers({
	get: getCoreSonarObjectsApplicationsAsyncSlice.asyncReducers
});

export const coreSonarObjectsApplicationsWatchers = combineAllWatchers([
	getCoreSonarObjectsApplicationsAsyncSlice.asyncWatchers
]);
